import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import metricsServices from '@/metrics/services/services'

import { transformResponsePerformanceInsightsAvailability } from './transformers'

const usePerformanceInsightsAvailability = ({ storeId, startDate, endDate, enabled }) => {
  const [settledRequest, setSettledRequest] = useState()

  const { data, loading, fetchDataCancellable } = useFetch(metricsServices.getPerformanceInsightsAvailability, {
    doInitialRequest: false,
    transformResponse: transformResponsePerformanceInsightsAvailability,
  })

  const requestKey = `${storeId}-${startDate}-${endDate}`
  const shouldRequest = enabled && Boolean(storeId)
  const isRequestSettled = settledRequest?.key === requestKey

  const refetchWhenArgsChange = () => {
    if (!shouldRequest) return

    fetchDataCancellable(
      { storeId, params: { start_date: startDate, end_date: endDate } },
      () => setSettledRequest({ key: requestKey, hasError: false }),
      () => setSettledRequest({ key: requestKey, hasError: true })
    )
  }

  useEffect(refetchWhenArgsChange, [endDate, fetchDataCancellable, requestKey, shouldRequest, startDate, storeId])

  return {
    availability: data,
    fetchingAvailability: loading || (shouldRequest && !isRequestSettled),
    availabilityError: isRequestSettled && settledRequest.hasError,
  }
}

export default usePerformanceInsightsAvailability
